<!-- Shell: Webflow landing includes its own nav/footer on /home. Other routes render full-width. -->
<main role="main" class="app-main">
  <router-outlet></router-outlet>
</main>
